import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import searchService from '../api/searchService';
import LoadingSpinner from '../components/common/LoadingSpinner';

/**
 * "Offres d'emploi" — Talentech RDC is a technician marketplace, so the opportunities are the
 * open trades: each active category is a stream of client demand a technician can plug into.
 */
export default function JobsPage() {
  const { t } = useTranslation();
  const [types, setTypes] = useState(null);

  useEffect(() => {
    searchService.technicianTypes().then(setTypes).catch(() => setTypes([]));
  }, []);

  return (
    <div className="page">
      <div className="container">
        <div className="page-head">
          <div>
            <h1>{t('jobs.title')}</h1>
            <p style={{ maxWidth: '60ch' }}>{t('jobs.subtitle')}</p>
          </div>
          <Link to="/register" className="btn accent">{t('jobs.ctaButton')}</Link>
        </div>

        {!types ? (
          <LoadingSpinner />
        ) : (
          <div className="grid cards">
            {types.map((x) => (
              <div key={x.id} className="card pad stack" style={{ gap: '.4rem' }}>
                <span className="badge blue" style={{ alignSelf: 'flex-start' }}>{t('common.new')}</span>
                <strong>{t('jobs.opportunitiesIn')} {x.name}</strong>
                <span className="muted" style={{ fontSize: '.88rem' }}>{x.description}</span>
                <span className="muted" style={{ fontSize: '.8rem' }}>
                  {t('jobs.techniciansActive', { count: x.technicianCount || 0 })}
                </span>
                <Link to="/register" className="btn ghost sm" style={{ alignSelf: 'flex-start', marginTop: '.25rem' }}>
                  {t('jobs.ctaButton')}
                </Link>
              </div>
            ))}
          </div>
        )}

        <div className="card pad center" style={{ marginTop: '1.5rem' }}>
          <p style={{ marginBottom: '.75rem' }}>{t('jobs.cta')}</p>
          <Link to="/register" className="btn accent">{t('jobs.ctaButton')}</Link>
        </div>
      </div>
    </div>
  );
}
